import moment from 'moment';

export default s => {
  if (!s || s == Number.POSITIVE_INFINITY || s == Number.NEGATIVE_INFINITY)
    return '0:00';
  return moment.utc(s * 1000).format((s < 3600) ? 'm:ss' : 'H:mm:ss');
};
